/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_PriceInputs */

const en_st_pricing_price = /** @type {(inputs: St_Pricing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp699k / $45`)
};

const id_st_pricing_price = /** @type {(inputs: St_Pricing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp699 rb / $45`)
};

/**
* | output |
* | --- |
* | "Rp699k / $45" |
*
* @param {St_Pricing_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_price = /** @type {((inputs?: St_Pricing_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_price(inputs)
	return en_st_pricing_price(inputs)
});